import script from "./DDualListSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DDualListSelector.vue?vue&type=script&setup=true&lang=js"

import "./DDualListSelector.vue?vue&type=style&index=0&id=1b71cc0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b71cc0c"]])

export default __exports__